const map = {
	"./en/analisecorporal.json": [
		17867,
		[
			7867
		]
	],
	"./en/auth.json": [
		23468,
		[
			3468
		]
	],
	"./en/camera.json": [
		36761,
		[
			6761
		]
	],
	"./en/caminho.json": [
		48471,
		[
			8471
		]
	],
	"./en/clubes.json": [
		8646,
		[
			8646
		]
	],
	"./en/competicao.json": [
		32832,
		[
			2832
		]
	],
	"./en/comum.json": [
		60661,
		[
			661
		]
	],
	"./en/config.json": [
		20040,
		[
			40
		]
	],
	"./en/dieta.json": [
		10047,
		[
			47
		]
	],
	"./en/educacao.json": [
		16475,
		[
			6475
		]
	],
	"./en/erros.json": [
		14675,
		[
			4675
		]
	],
	"./en/gamificacao.json": [
		52734,
		[
			2734
		]
	],
	"./en/inicio.json": [
		81441,
		[
			1441
		]
	],
	"./en/legal.json": [
		77063,
		[
			7063
		]
	],
	"./en/moedas.json": [
		44407,
		[
			4407
		]
	],
	"./en/notificacoes.json": [
		23549,
		[
			3549
		]
	],
	"./en/onboarding.json": [
		41947,
		[
			1947
		]
	],
	"./en/paywall.json": [
		42404,
		[
			2404
		]
	],
	"./en/perfil.json": [
		87884,
		[
			7884
		]
	],
	"./en/progresso.json": [
		25958,
		[
			5958
		]
	],
	"./en/scanbody.json": [
		38763,
		[
			8763
		]
	],
	"./en/scanfood.json": [
		70603,
		[
			603
		]
	],
	"./en/social.json": [
		19521,
		[
			9521
		]
	],
	"./en/treino.json": [
		19321,
		[
			9321
		]
	],
	"./pt-BR/analisecorporal.json": [
		78107,
		[
			8107
		]
	],
	"./pt-BR/auth.json": [
		86620,
		[
			6620
		]
	],
	"./pt-BR/camera.json": [
		96041,
		[
			6041
		]
	],
	"./pt-BR/caminho.json": [
		95399,
		[
			7780
		]
	],
	"./pt-BR/clubes.json": [
		64790,
		[
			4790
		]
	],
	"./pt-BR/competicao.json": [
		37488,
		[
			7488
		]
	],
	"./pt-BR/comum.json": [
		38021,
		[
			8021
		]
	],
	"./pt-BR/config.json": [
		40344,
		[
			344
		]
	],
	"./pt-BR/dieta.json": [
		77839,
		[
			7839
		]
	],
	"./pt-BR/educacao.json": [
		17227,
		[
			7227
		]
	],
	"./pt-BR/erros.json": [
		70787,
		[
			787
		]
	],
	"./pt-BR/gamificacao.json": [
		22222,
		[
			2222
		]
	],
	"./pt-BR/inicio.json": [
		5937,
		[
			5937
		]
	],
	"./pt-BR/legal.json": [
		9847,
		[
			9847
		]
	],
	"./pt-BR/moedas.json": [
		35399,
		[
			5399
		]
	],
	"./pt-BR/notificacoes.json": [
		19373,
		[
			9373
		]
	],
	"./pt-BR/onboarding.json": [
		64139,
		[
			4139
		]
	],
	"./pt-BR/paywall.json": [
		84372,
		[
			4372
		]
	],
	"./pt-BR/perfil.json": [
		96412,
		[
			6412
		]
	],
	"./pt-BR/progresso.json": [
		17014,
		[
			7014
		]
	],
	"./pt-BR/scanbody.json": [
		16379,
		[
			6379
		]
	],
	"./pt-BR/scanfood.json": [
		23835,
		[
			3835
		]
	],
	"./pt-BR/social.json": [
		95985,
		[
			5985
		]
	],
	"./pt-BR/treino.json": [
		42857,
		[
			2857
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 76020;
module.exports = webpackAsyncContext;